<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="cms/blog-category/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { BlogCategory } from '@/modules/cms/data/blog-category/create'
	import { BlogCategoryService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return BlogCategory;
			},

			service()
			{
				return new BlogCategoryService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>